import {Database} from '@tnc/shared';

import {sortOptionViewT} from '@/lib/types/dataTableView.types';

type sortOptionsViewT = {
  [K in keyof Database['public']['Views']]?: sortOptionViewT<K>[];
};

export const SORT_OPTIONS_VIEW: sortOptionsViewT = {
  // Define view-specific sort options here
  // Add more view sort options as needed
};

export const getSortOptionsForView = <V extends keyof Database['public']['Views']>(view: V) => {
  const viewSortOptions = SORT_OPTIONS_VIEW[view] || [];

  // Add default date options if they don't exist
  const dateCreatedColumn = 'date_created' as keyof Database['public']['Views'][V]['Row'];

  const additionalOptions: sortOptionViewT<V>[] = [
    {
      label: 'New',
      column: dateCreatedColumn,
      direction: 'desc',
    },
    {
      label: 'Old',
      column: dateCreatedColumn,
      direction: 'asc',
    },
  ];

  return [...viewSortOptions, ...additionalOptions];
};
